<template>
  <b-card>
    <b-row class="mb-3">
      <b-col>
        <b-button @click="addFile">Adicionar arquivo</b-button>
      </b-col>
    </b-row>
    <b-row v-for="(file, idx) of files" :key="file._id">
      <b-col class="d-flex">
        <template v-if="file.path">
          <b-form-group :label="file.name" class="flex-grow-1">
            <b-button variant="link" @click="downloadFile(file)"
              >Ver atual
            </b-button>
            <b-button variant="light" @click="file.path = null">
              Substituir
            </b-button>
            <!--                        <b-button-->
            <!--                          class="ml-3"-->
            <!--                          variant="danger"-->
            <!--                          @click="files.splice(idx, 1)"-->
            <!--                        >Remover</b-button>-->
          </b-form-group>
        </template>
        <template v-else>
          <b-form-group label="Arquivo" class="flex-grow-1">
            <div class="d-flex">
              <b-form-input
                v-model="file.name"
                v-validate="{ required: true }"
                type="text"
                class="form-control mr-2"
                placeholder="Nome"
                :aria-describedby="`invalidFile${idx}Name`"
                :name="`file${idx}Name`"
                :state="validateState(`file${idx}Name`)"
                data-section="compliance"
              ></b-form-input>
              <b-form-file
                v-model="file.file"
                placeholder="Selecione um arquivo PDF."
              ></b-form-file>
              <!--                        <b-button-->
              <!--                          class="ml-3 form-group"-->
              <!--                          variant="danger"-->
              <!--                          @click="files.splice(idx, 1)"-->
              <!--                        >Remover</b-button>-->
            </div>
          </b-form-group>
        </template>
      </b-col>
    </b-row>
    <a
      ref="download"
      class="invisible"
      target="_blank"
      :download="download.name"
      :href="download.link"
    ></a>
    <b-card-footer>
      <span v-if="upload.visible">Enviando {{ upload.filename }}...</span>
      <b-progress
        v-if="upload.visible"
        class="mb-2"
        :value="upload.value"
        :max="100"
        show-progress
      ></b-progress>
      <b-button
        variant="primary"
        class="px-4"
        :disabled="loading"
        @click="onSaveClicked"
        >Salvar</b-button
      >
      <b-button class="px-4 ml-1" :disabled="loading" @click="goBack"
        >Cancelar</b-button
      >
    </b-card-footer>
  </b-card>
</template>

<script>
import {
  getCompany,
  editCompany,
  newCompany,
  sendCompanyFile,
} from "../../api/company";

import { mapGetters } from "vuex";

import { mask } from "vue-the-mask";

export default {
  name: "CompanyView",
  directives: { mask },
  data() {
    return {
      download: {
        name: null,
        link: null,
      },
      loading: false,
      company: {
        compliance: {
          files: [],
        },
      },
      files: [],
      upload: {
        value: 0,
        visible: false,
        filename: "",
      },
    };
  },
  computed: {
    ...mapGetters(["profile", "portalBucket"]),
  },
  async created() {
    const companyId = this.profile.company;

    const response = await getCompany(companyId);
    this.company = response.data;

    if (this.company.compliance.files) {
      this.unpackCurrentFiles(this.company);
    }
  },
  methods: {
    addFile() {
      this.files.push({
        _id: `new-${this.files.length}`,
      });
    },
    unpackCurrentFiles(company) {
      const files = company.compliance.files;

      for (const file of files) {
        this.files.push({
          _id: file._id,
          name: file.name,
          path: file.path,
        });
      }
    },
    goBack() {
      this.$router.go(0);
    },
    validateState(ref) {
      if (
        this.vFields[ref] &&
        (this.vFields[ref].dirty || this.vFields[ref].validated)
      ) {
        return !this.errors.has(ref);
      }
      return null;
    },

    downloadFile(file) {
      const filename = file.path;
      this.download.name = `${file.name}.${filename.substr(
        filename.lastIndexOf(".")
      )}`;
      this.download.link = `https://${this.portalBucket}/${filename}`;
      this.$nextTick(() => {
        this.$refs["download"].click();
      });
    },

    async onSaveClicked() {
      const filesToUpload = [];
      const filesToDelete = [];

      let totalSize = 0;

      for (const item of this.company.compliance?.files || []) {
        if (!this.files.find((f) => f._id === item._id)) {
          filesToDelete.push(item._id);
        }
      }
      for (const item of this.files) {
        if (item.file) {
          filesToUpload.push(item);
          totalSize += item.file.size;
        }
      }

      const validated = await this.validateFields();
      if (!validated) return;

      this.loading = true;

      let loaded = 0;
      this.upload.visible = true;
      for (const item of filesToUpload) {
        this.upload.filename = item.name;
        await sendCompanyFile(this.company._id, item, (evt) => {
          this.upload.value = ((loaded + evt.loaded) / totalSize) * 100;
        });
        loaded += item.file.size;
      }
      this.upload.visible = false;

      this.loading = false;
      this.goBack(-1);
    },
    async validateFields() {
      this.sectionErrorCount = {};
      const validated = await this.$validator.validateAll();
      if (!validated) {
        for (const error of this.errors.items) {
          const field = error.field;
          let el = document.getElementsByName(field)[0];
          if (el && el.type === "file") {
            el = el.parentElement;
          }
          if (el && el.hasAttribute("data-section")) {
            const section = el.getAttribute("data-section");
            this.sectionErrorCount[section] =
              this.sectionErrorCount[section] || 0;
            this.sectionErrorCount[section] =
              this.sectionErrorCount[section] + 1;
          }
        }
      }

      this.$nextTick(() => this.$forceUpdate());

      return validated;
    },
  },
};
</script>

<style>
.custom-file-input ~ .custom-file-label::after {
  content: "Escolher";
}
</style>
